import React from 'react';

/** Passthrough layout — floating notes and texture are handled globally in App.js */
export default function SidebarLayout({ children }) {
  return children;
}
